import { render, staticRenderFns } from "./submittedTemp.vue?vue&type=template&id=656819fb&scoped=true&"
import script from "./submittedTemp.vue?vue&type=script&lang=js&"
export * from "./submittedTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656819fb",
  null
  
)

component.options.__file = "submittedTemp.vue"
export default component.exports